/* eslint-disable no-useless-catch */
// Copyright (c) 2019 Deere & Company
import * as fetchService from '../../../sharedmodules/services/fetch';

const basePath = '/api';

const headerOptions = (accessToken) => ({
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
});

export async function addNotification(getAccessToken, notification) {

    const endPoint = `${basePath}/notifications`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
        },
        body: JSON.stringify(notification),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return await response;

    } catch (error) {

        throw error;

    }

}
